export default ({
  formikProps: {
    values: { slug },
  },
}) => slug === 'temperature-outside-range'
